import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { store } from "./store";
import App from "./App";
import "./index.css";
import { GoogleOAuthProviderWrapper } from "./GoogleOAuthProviderWrapper";
import { ProfileUpdateListenerProvider } from "./context/ProfileUpdateListenerProvider";
const ANALYTICS_ENABLED = import.meta.env.VITE_ANALYTICS_ENABLED === "true";
import { detectPlatform, setPlatform, initAmplitude } from "./utils/amplitude";

const container = document.getElementById("root")!;
const root = createRoot(container);
const queryClient = new QueryClient();

if (ANALYTICS_ENABLED) {
  const platform = detectPlatform();
  setPlatform(platform);
  initAmplitude();
}

root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <GoogleOAuthProviderWrapper>
          <ProfileUpdateListenerProvider>
            <App />
          </ProfileUpdateListenerProvider>
        </GoogleOAuthProviderWrapper>
      </BrowserRouter>
    </QueryClientProvider>
  </Provider>
);
